
<div class="modal-dialog confirm-dialog" style="max-width: 50%;">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">{{title}}</h5>
      <button class="close" type="button" (click)="cancel()">&times;</button>
    </div>
    <div class="modal-body"><span class="pl20">
        <p style="white-space: pre-wrap;" [innerHTML]="message"></p></span>
      <label class="required" for="messageTextArea" style="font-size: 0.9em;">Please describe the reason for Deleting project.</label>
      <textarea class="form-control" id="messageTextArea" [(ngModel)]="inputText" name="inputText" maxlength="500" required></textarea>
      <!-- Add a section to display the error message-->
      <div class="error-message" style="color: red;" *ngIf="errors">{{errors.message}}</div>
      <validation-error-display [error]="errors" field="inputText"></validation-error-display>
    </div>
    <div class="modal-footer">
      <button class="btn btn-outline-secondary" type="button" (click)="cancel()">{{cancelText}}</button>
      <button class="btn btn-primary" type="button" (click)="ok()">{{confirmText}}</button>
    </div>
  </div>
</div>